import { render, staticRenderFns } from "./carViolationRecordList.vue?vue&type=template&id=38264fa5&scoped=true"
import script from "./carViolationRecordList.vue?vue&type=script&lang=js"
export * from "./carViolationRecordList.vue?vue&type=script&lang=js"
import style0 from "./carViolationRecordList.vue?vue&type=style&index=0&id=38264fa5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38264fa5",
  null
  
)

export default component.exports